import Reveal from "@/components/Reveal";
import { scrollToSection } from "@/data/catalog";
import { ArrowUpRight } from "lucide-react";

const STEPS = [
  {
    num: "01",
    title: "Position",
    body: "We audit your profiles and content, then define the one thing your brand should be famous for. Every campaign starts from a sharp position, not random boosts.",
  },
  {
    num: "02",
    title: "Ignite",
    body: "Targeted follower and engagement bursts build the social proof that triggers each platform's discovery algorithm — paced to look organic and protect your accounts.",
  },
  {
    num: "03",
    title: "Amplify",
    body: "Cross-platform pushes: video views, music plays, story reach and website traffic stack on each other so every channel feeds the next.",
  },
  {
    num: "04",
    title: "Convert",
    body: "Precision-targeted ad campaigns retarget the attention we've built and turn visibility into sales, streams and sign-ups.",
  },
];

export default function StrategySection() {
  return (
    <section id="strategy" data-testid="strategy-section" className="relative border-t border-[#1F1F1F] bg-[#050505] py-24 lg:py-32">
      <div className="pointer-events-none absolute -left-32 top-1/4 h-[380px] w-[380px] rounded-full bg-[#E11D2E]/[0.06] blur-[140px]" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E11D2E]">Brand growth</p>
          <h2 className="mt-4 font-display text-4xl uppercase leading-[1.02] tracking-tight text-white sm:text-5xl">
            The Mobilize Method.
            <span className="block text-[#E11D2E]">Our growth strategy.</span>
          </h2>
          <p className="mt-5 max-w-lg text-sm leading-relaxed text-[#8A8A8A] md:text-base">
            Strategic marketing solutions designed to build your brand and drive real results — a
            four-stage system we run for every artist, creator and business.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.08} data-testid={`strategy-step-${s.num}`}>
              <div className="group h-full border border-[#1F1F1F] bg-[#0D0D0D] p-6 transition-all duration-500 hover:-translate-y-1 hover:border-[#E11D2E]/50 hover:shadow-[0_0_40px_rgba(225,29,46,0.12)]">
                <span className="font-mono text-3xl font-700 text-[#E11D2E]">{s.num}</span>
                <h3 className="mt-5 font-display text-lg uppercase tracking-wide text-white">{s.title}</h3>
                <p className="mt-3 text-xs leading-relaxed text-[#8A8A8A]">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-10">
          <button
            data-testid="strategy-cta"
            onClick={() => scrollToSection("#contact")}
            className="group flex items-center gap-2 bg-[#E11D2E] px-7 py-4 font-mono text-xs font-600 uppercase tracking-[0.14em] text-white transition-all duration-300 hover:bg-[#F13B47] hover:shadow-[0_0_32px_rgba(225,29,46,0.4)]"
          >
            Get your growth plan
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
